import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ajaxCall } from './axios'

const initialState = {
  listProcess: [],
  newProcess: null,
  page: 2,
  totalPages: null,
}

export const processing = createSlice({
  name: 'processing',
  initialState,
  reducers: {
    updateListProcess: (state, action) => {
      state.listProcess = action.payload.elements
    },
    updateProcessingNumber: (state, action) => {
      state.newProcess = action.payload.total
    },
    updatePageProcess: (state, action) => {
      state.page = action.payload
    },
    updateNumTotalProcess: (state, action) => {
      state.totalPages = action.payload
    },
  },
})

export const { updateProcessingNumber, updateListProcess, updatePageProcess, updateNumTotalProcess } =
  processing.actions

export const getProcessList = createAsyncThunk(
  'processing/getProcess',
  async (path, thunkAPI) => {
    thunkAPI.dispatch(
      ajaxCall({
        config: {
          url: path,
          method: 'get',
          params: { page: 1 },
        },
        success: (res) => {
          thunkAPI.dispatch(updateListProcess(res.data))
          thunkAPI.dispatch(updateNumTotalProcess(res.data.totalPages))
          thunkAPI.dispatch(updateProcessingNumber(res.data))
        },
        error: () => {},
        activeLoading: false,
      })
    )
  }
)

export default processing.reducer
